import './styles.scss';
import Banner from '../../components/stats-banner'
import Ticker from '../../components/stats-ticker'
import CustomStats from '../../components/custom-stats'
import { Table } from '../../components/stats-ticker'
import Charts from '../../components/chart-carousel'
import News from '../../components/news-list'
import SOTD from '../../components/sotd'
import About from './about'
import ons from 'onsenui';
import analytics from '../../analytics'



export default function() {
  let navigator, menu
  let tab = 'world'
  let page = 'home'
  let nav = page => e => {
    tab = page
  }
  const pushSearch = (e) => {
    navigator.pushPage('landing-search');
  }
  const openMenu = (e) => {
    menu.open()
  }

  let countyData
  const pushCounty = (data) => {
    countyData = data
    // remove state column
    countyData.meta.fields = countyData.meta.fields.filter(x => x !== 'state')
    navigator.pushPage('counties-table')
  }

  let chartData
  const pushCharts = (data) => {
    chartData = data
    navigator.pushPage('charts-carousel')

    let postpop = () => {
      chartData = null
      m.redraw()
      navigator.removeEventListener('postpop', postpop)
    }
    navigator.addEventListener('postpop', postpop)
  }


  return {
    oncreate(vnode) {
      navigator = vnode.dom.querySelector('ons-navigator')
      navigator.pageLoader = ons.domLoader
      navigator.page = 'landing-home'

      menu = vnode.dom.querySelector('ons-splitter-side')
    },
    view() {
      return m(".landing",
        m("ons-splitter", [
          m("ons-splitter-side#menu[collapse='']",
            m("ons-page",
              m("ons-list", [
                m("ons-list-item[tappable]", { onclick: e => page = 'home' }, " Home "),
                false && m("ons-list-item[tappable='']", " Settings "),
                m("ons-list-item[tappable]", { onclick: e => page = 'about' }, " About "),
                m("ons-list-item[tappable]", {
                  onclick: () => window.location.reload(true)
                }, " Refresh ")
              ])
            )
          ),
          m("ons-splitter-content",
            m("ons-navigator[swipeable='']", {
              style: page === 'home' ? '' : 'display:none;'
            }),
            page === 'about' &&
            m("ons-page#landing-home", [
              m("ons-toolbar", [
                m(".left",
                  m("ons-toolbar-button[icon='md-menu']", {
                    onclick: openMenu
                  }),
                ),
                m(".center", "About"),
              ]),
              m(About),
            ]),
          )
        ]),

        m(".templates", [
          m("ons-page#landing-home", [
            m("ons-toolbar", [
              m("div.left",
                m("ons-toolbar-button[icon='md-menu']", {
                  onclick: openMenu
                }),
                m("span.brand", "Corona Pulse",
                  m("img.logo", { src: "/assets/logo/pulse.svg" })
                )
              ),
              // m("div.center", "COVID-19 Tracker"),
              false && m("div.right",
                m("ons-toolbar-button[icon='md-search']", {
                  onclick: pushSearch
                })
              )
            ]),
            m(".fastbar",
              m("ons-button[modifier='quiet']", {
                onclick: nav('world'),
                active: tab === 'world'
              }, "World"),
              m("ons-button[modifier='quiet']", {
                onclick: nav('USA'),
                active: tab === 'USA'
              }, "USA"),
              m("ons-button[modifier='quiet']", {
                onclick: nav('metros'),
                active: tab === 'metros'
              }, "Metros"),
              m("ons-button[modifier='quiet']", {
                onclick: nav('pulse'),
                active: tab === 'pulse'
              }, "My Pulse"),
              m("ons-button[modifier='quiet']", {
                onclick: nav('news'),
                active: tab === 'news'
              }, "Top News"),
              false && m("ons-button[modifier='quiet']", "Compare")
            ),
            m("div",
              tab === 'USA' ? [
                m('.body', [
                  m("h2", "Coronavirus in the USA"),
                  m(Ticker, {
                    geo: 'USA',
                    pushCounty,
                    pushCharts
                  }),
                  /*
                  m("ons-button[modifier='large']", {
                    style: 'margin-top: 1rem;',
                    onclick: () => ons.notification.toast('TODO', {
                      timeout: 2000
                    })
                  }, "View Graphs")
                  */
                ])
              ] :
              tab === 'metros' ? [
                m('.body', [
                  m("h2", "Coronavirus grouped by US Metros"),
                  m(Ticker, {
                    geo: 'USmetro',
                    pushCharts
                  }),
                ])
              ] :
              tab === 'world' ? [
                m('.body', [
                  m("h2", "Coronavirus Around the World"),
                  m(Ticker, {
                    geo: 'index',
                    pushCharts
                  }),
                ])
              ] :
              tab === 'pulse' ? [
                m('.body', [
                  m("h2", "My Pulse"),
                  m(CustomStats, {
                    pushCharts
                  }),
                ])
              ] :
              tab === 'news' ? [
                m("div", m(Banner)),
                m(".body", [
                  m("h2", "Summary of the Day"),
                  m(SOTD),
                  m('hr'),
                  m("h2", "Top News"),
                ]),
                m(News),
              ] : null
            )
          ]),

          m("ons-page#landing-search", [
            m("ons-toolbar", [
              m("div.left",
                m("ons-back-button", "Back")
              ),
              m("div.center", [
                "Search"
              ])
            ]),
            m(".body", [
              m("ons-search-input.searchbar", {
                placeholder: 'Search',
                onchange: (e) => ons.notification.alert("Searched for: " + e.target.value)
              })
            ])
          ]),

          m("ons-page#counties-table",
            m("ons-toolbar", [
              m("div.left",
                m("ons-back-button", "USA")
              ),
              m("div.center", [
                countyData ? countyData.stateName : ''
              ])
            ]),
            m("div",
              countyData ?
              m(".body", [
                m("h2", `Coronavirus in ${countyData.state} by County`),
                m(Table, { ...countyData, pushCharts }),
              ]) : null
            )
          ),

          m("ons-page#charts-carousel",
            m("ons-toolbar", [
              m("div.left",
                m("ons-back-button", "Back")
              ),
              m("div.center", [
                chartData ? `${chartData.geoName} (${chartData.charts ? chartData.charts.length : '...loading'} chart${chartData.charts && chartData.charts.length === 1 ? '' : 's'})` : ''
              ]),
              m("div.right",
                chartData && chartData.zoom ?
                m("ons-toolbar-button[icon='fa-arrows-h']", {
                  onclick: () => chartData.zoom = false
                }) :
                m("ons-toolbar-button[icon='fa-bullseye']", {
                  onclick: () => chartData.zoom = true
                })
              ),
            ]),
            m(Charts, chartData)
          )
        ]),
      )
    },
  };
}
